import axios from 'axios';

const SERVER_URL = 'https://node.thor.financial';

export async function fetchHistoricalData(id, interval, count = 10) {
  return axios
    .get(`${SERVER_URL}/coinmarketcap/fetchHistoricalData?id=${id}&interval=${interval}&count=${count}`, {
      headers: {
        'X-CMC_PRO_API_KEY': process.env.REACT_APP_COIN_MARKET_API_KEY,
      },
    })
    .then((res) => res.data);
}

export async function fetchSingleSymbolPrice(id) {
  return axios
    .get(`${SERVER_URL}/coinmarketcap/fetchSingleSymbolPrice?id=${id}`, {
      headers: {
        'X-CMC_PRO_API_KEY': process.env.REACT_APP_COIN_MARKET_API_KEY,
      },
    })
    .then((res) => res.data);
}
